/**
 * Função que converte json e FormData
 * @param formData json com campos do formulário
 * @return FormData
 */
export function toFormData(formData) {
    let data = new FormData();

    // Adicionar automaticamente todas as propriedades de this.formData
    Object.keys(formData).forEach(key => {

        if (formData[key] === null || formData[key] === '' || formData[key] === 'null') {
            data.append(key, '');
            // Adicionar ao FormData se for uma string, número ou booleano
        } else if (typeof formData[key] === 'string' || typeof formData[key] === 'number') {
            data.append(key, formData[key]);
            // Adicionar ao FormData se for um boolean
        } else if (typeof formData[key] === 'boolean') {
            data.append(key, formData[key] ? '1' : '0');
        } else if (formData[key] instanceof File) {
            // Adicionar ao FormData se for um arquivo
            data.append(key, formData[key]);
        } else {
            // Tratar como array/objeto
            data = toFormDataArray(data, key, formData[key]);
        }

    });

    return data;
}

/**
 * Função para inserir os sub-arrays no FormData de origem
 * @param data
 * @param key
 * @param array
 * @return {*}
 */
function toFormDataArray(data, key, array) {

    Object.keys(array).forEach(k => {
        if (array[k] != null && array[k] !== '' && array[k] !== 'null') {
            if (typeof array[k] === 'string' || typeof array[k] === 'number') {
                data.append(`${key}[${k}]`, array[k]);
            } else if (typeof array[k] === 'boolean') {
                data.append(`${key}[${k}]`, array[k] ? '1' : '0');
            } else if (array[k] instanceof File) {
                data.append(`${key}[${k}]`, array[k]);
            } else {
                data = toFormDataArray(data, `${key}[${k}]`, array[k]);
            }
        }

    });

    return data;
}



// WEBPACK FOOTER //
// ./src/composables/cruds.js